import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CookieUtil } from '@utils/cookies';
import { Title } from '@angular/platform-browser';
import { UtilsMethods_Services } from '@utils/utils';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@enviroment/environment';
import { getDataCampaign } from '@utils/get-campaign';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ValidateTokenService } from '@apiShared/user/token/validate-token.service';
import { SignOut_Util } from '@utils/sign-out';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertConfirmComponent } from './resources-alerts/alert-confirm/alert-confirm.component';
import { CloseModal } from '@class/close-modal/close-modal';
import { Globals } from '@config/global';
import { NotificacionService } from '@utils/notificacion';
import { ScriptLoaderService } from '@apiShared/scripts/scripts-loaders.service';
import { AnalyticsManagerService } from './services/analytics-manager.service';
import { RobotsService } from '@apiShared/robots/robots.service';
import { GlobalQueryParamsPreserverService } from '@apiShared/querys-params-preserver/querys-params-preserver.service';
import { ScreenService } from '@utils/screen';
import { AcquisitionChannelUtil } from '@utils/acquisition-channel.util';

declare let gtag: Function;

declare global {
  var HubSpotConversations: {
    widget: {
      remove: () => void;
      load: () => void;
      open: () => void;
    };
  };
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  private tokenExpirationSubscription!: Subscription;
  private destroy$ = new Subject<void>();

  resolution?: number = 0;
  env = environment;
  title = 'MejorCDT';
  retryAttempts = 5; // Número máximo de intentos para checkQueryParam
  favicons!: { [key: string]: HTMLLinkElement };
  mouseInactive: number = 0;
  flagMouseActive: boolean = false;
  flagModalDownloadApp: boolean = false;
  timeMouseActive: number = 35000;
  observer: MutationObserver | undefined;
  pageNotAllowedBonusGift: any = [
    '/preguntas/coltefinanciera/flamingo',
    '/preguntas-ban100',
    '/preguntas-bancamia',
    '/preguntas-bancow',
    '/preguntas-bancomundomujer',
    '/preguntas-mibanco',
    '/preguntas-coltefinanciera',
    '/preguntas-credifamilia',
    '/preguntas-iris',
    '/datos-personales',
    '/datos-financieros',
    '/sube-tus-documentos',
    '/asegura-tu-tasa',
    '/transfiere-el-dinero',
    '/cdt-completado',
    '/ops/dashboard',
    '/portal/login',
    '/portal/dashboard',
    '/portal/referrer',
    '/login',
    '/verificando-firma',
    '/mis-procesos',
    '/continuar-proceso',
    '/no-podemos-continuar-con-tu-proceso',
    '/firma-los-documentos-en-fisico',
    '/trabajo',
    '/validar-identidad',
    '/hoy-los-bancos-ofrecen',
    '/pauta/remarketing/hoy-los-bancos-ofrecen',
    '/pauta/llamada/hoy-los-bancos-ofrecen',
    '/pauta/control/hoy-los-bancos-ofrecen',
    '/cdt-simulador?promo=gift-voucher',
    '/golf18',
    '/a-unos-minutos-de-abrir-tu-cdt',
    '/cdt-simulador',
    '/orden-inversion',
    '/cancelacion',
    '/4B6XN8K2H7VY3W9M5Q1Z9A3JN7M5D1H8S4L0F2K',
    '/dias-azules',
    '/sueldo-inteligente',
    '/referidos',
    '/referidos/terminos',
    '/cdt-nicolasabril',
    '/cdt-arenalfa',
    '/cdt-financiatuvida',
    '/cdt-claudiauribe',
    '/confirma-tus-datos',
    '/bienvenida-usuario-retorno',
    '/preguntas-credifamilia',
    '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
    '/v2/preguntas-ban100',
    '/v2/preguntas-bancamia',
    '/v2/preguntas-bancow',
    '/v2/preguntas-bancomundomujer',
    '/v2/preguntas-mibanco',
    '/v2/preguntas-credifamilia',
    '/v2/preguntas-coltefinanciera',
    '/v2/preguntas-iris',
    '/v2/preguntas-bancounion',
    '/v2/preguntas-cdturbo',
    '/v2/datos-personales',
    '/v2/datos-financieros',
    '/cdt-turbo',
    '/club-cdt',
    '/ab-testing/cdt-simulador',
    '/moneycon',
    '/legal/bono-regalo',
  ];

  @ViewChild('appContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  timeoutId: any;
  chatLoadedByScroll: boolean = false;
  private hubspotListenersAdded = false;

  constructor(
    private ngZone: NgZone,
    private cookies: CookieUtil,
    private utils: UtilsMethods_Services,
    private signOut: SignOut_Util,
    private closeModal: CloseModal,
    private notification: NotificacionService,
    private _getDataCampaign: getDataCampaign,
    private modal: NgbModal,
    private validateToken: ValidateTokenService,
    private router: Router,
    private renderer: Renderer2,
    private globals_var: Globals,
    private scriptLoader: ScriptLoaderService,
    private analyticsManager: AnalyticsManagerService,
    private titlePage: Title,
    private _screenService: ScreenService,
    private robotsService: RobotsService, // No remover
    private queryParamsPreserver: GlobalQueryParamsPreserverService, // No remover
    private acquisitionChannel: AcquisitionChannelUtil, // No remover
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.favicons = {
        ico16: document.querySelector('link[rel="icon"][sizes="16x16"]') as HTMLLinkElement,
        ico32: document.querySelector('link[rel="icon"][sizes="32x32"]') as HTMLLinkElement,
        ico48: document.querySelector('link[rel="icon"][sizes="48x48"]') as HTMLLinkElement,
        ico64: document.querySelector('link[rel="icon"][sizes="64x64"]') as HTMLLinkElement,
        ico128: document.querySelector('link[rel="icon"][sizes="128x128"]') as HTMLLinkElement,
      };

      this.isMobileSubscribe();
      this.campaignVIP();

      if (this.env.BRAND != 'mcdt') {
        this.utils.loadWhiteLabelData(this.env.BRAND).then((data) => {
          this.titlePage.setTitle(data.seo.title);
        });
      }
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.acquisitionChannel.detectAndSave();

      const check_id_token_user = this.cookies.check('id_token_user');
      if (check_id_token_user) {
        this.startTokenExpirationCheck();
      }

      this.backToStep();
      this.RefInfluencer('ref');

      this.LoadChatFaviconBrand();
      // Solo configura listeners (0 impact), carga diferida mantenida
      this.analyticsManager.initializeAnalytics();

      // Cargar otros scripts third-party diferidos
      this.scriptLoader.initThirdPartyListeners();
    }
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.renderer.listen('window', 'scroll', () => {
      this.onWindowScroll();
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.activateCampaign();
        }, 100); // Permite que el navegador renderice primero

        // Cargar HammerJS dinámicamente
        this.loadHammerJs();

        const ID_APLICATION_TUBO_MCDT: any = document.getElementById('aplication-tubo-mcdt');
        if (ID_APLICATION_TUBO_MCDT) {
          while (ID_APLICATION_TUBO_MCDT.classList.length > 0) {
            ID_APLICATION_TUBO_MCDT.classList.remove(ID_APLICATION_TUBO_MCDT.classList.item(0));
          }

          const path = window.location.pathname.replaceAll('/', '_');
          if (path) {
            this.renderer.addClass(ID_APLICATION_TUBO_MCDT, path);
          }
        }

        // Lógica unificada para recargar el chat/favicon en la navegación
        this.ngZone.run(() => {
          setTimeout(() => {
            this.retryAttempts = 5;
            this.LoadChatFaviconBrand();
          }, 1000);
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.stopObserving();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  /**
   * @description Suscribe al servicio de pantalla para detectar si es móvil.
   * Actualiza la variable `resolution` según el estado del servicio.
   */
  isMobileSubscribe() {
    this._screenService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((screen) => {
      this.resolution = screen;
    });
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  loadHammerJs() {
    if (isPlatformBrowser(this.platformId)) {
      // Solo cargar HammerJS si la ruta actual lo necesita
      const currentPath = window.location.pathname;
      const routesThatNeedHammer = [
        '/', // Home con carruseles
        '/home', // Home module
        '/cdt-simulador', // Simulador con gestures
        '/mejores-bancos-para-cdt-hoy', // Carruseles
        '/mejores-tasas-para-cdt-hoy', // Carruseles
        '/club-cdt', // Interacciones touch
        '/cdt-turbo', // Carruseles
        '/portal/dashboard', // Dashboard interactivo
      ];

      // También cargar para rutas que empiecen con ciertos patrones
      const routePatternsThatNeedHammer = [
        '/mejores-cdt-', // Rutas de mejores CDT del mes
        '/cdt-', // Páginas específicas de bancos
      ];

      const needsHammer =
        routesThatNeedHammer.includes(currentPath) ||
        routePatternsThatNeedHammer.some((pattern) => currentPath.startsWith(pattern));

      if (needsHammer) {
        import('hammerjs').then(() => {});
      }
    }
  }

  activateCampaign() {
    this._getDataCampaign.activateCampaignData().subscribe({
      error: (err) => console.error('Error: ', err),
    });
  }

  campaignVIP() {
    this.notification.receiveNotificacion.subscribe((data: any) => {
      let api = data.api;
      switch (api) {
        case 'api_notification_activate_VIP':
          const ID_PROJECT_MCDT_ELEM = document.getElementById('project-mcdt');
          if (ID_PROJECT_MCDT_ELEM) {
            this.renderer.addClass(ID_PROJECT_MCDT_ELEM, 'vip-activate');
          }
          break;

        default:
          break;
      }
    });
  }

  /*
   * Genera un mensaje dinámico dependiendo del día de la semana.
   * Si hoy es jueves antes de las 3:00 PM, devuelve un mensaje específico.
   * Si hoy es viernes, devuelve un mensaje para el próximo viernes.
   * En cualquier otro día, devuelve un mensaje para el próximo viernes después del día actual.
   * @returns El mensaje dinámico generado.
   */
  generateDynamicMessage(): string {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const textContinue = 'y recibe gratis un bono regalo de <b>$50.000</b>';
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    // Verificar si hoy es jueves y si es antes de las 3:00 PM
    if (dayOfWeek === 5) {
      const now = new Date();
      const cutoffTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0); // 3:00 PM

      if (now < cutoffTime) {
        return '<b>hoy antes de las 3:00pm</b> para que recibas gratis un bono regalo de <b>$50.000</b> ';
      }
    }
    // Si hoy es viernes, mostrar el mensaje para el próximo viernes
    else if (dayOfWeek === 5) {
      const nextFriday = new Date(today);
      nextFriday.setDate(today.getDate() + 7); // Obtener el próximo viernes

      const day = nextFriday.getDate();
      const monthIndex = nextFriday.getMonth();
      const month = months[monthIndex].charAt(0).toUpperCase() + months[monthIndex].slice(1);
      const year = nextFriday.getFullYear();

      return `<b>antes del próximo Viernes ${day} de ${month} de ${year}</b> a las 3:00pm,  ${textContinue}`;
    }

    // Si no es jueves ni viernes, mostrar el mensaje para el próximo viernes después del día actual
    const nextFriday = new Date(today);
    nextFriday.setDate(today.getDate() + ((5 - dayOfWeek + 7) % 7)); // Obtener el próximo viernes

    const day = nextFriday.getDate();
    const monthIndex = nextFriday.getMonth();
    const month = months[monthIndex].charAt(0).toUpperCase() + months[monthIndex].slice(1);
    const year = nextFriday.getFullYear();

    return `<b>antes del próximo Viernes ${day} de ${month} de ${year}</b> a las 3:00pm, ${textContinue}`;
  }

  acceptedAsGift() {
    this.cookies.save('activate_promo', 'true', 1);
    this.router.navigate(['/cdt-simulador'], { queryParams: { promo: 'gift-voucher' } });
  }

  openAlertConfirmation(
    modalData: { title: string; message: string; textButtons: {}; no_padding_header: boolean },
    execute: () => void,
  ) {
    if (this.mouseInactive <= 1) {
      const modalRef = this.modal.open(AlertConfirmComponent, {
        centered: true,
        backdrop: 'static',
        size: 'modal-alert-bono-regalo-50k-zoom',
      });
      modalRef.componentInstance.modalData = modalData;
      modalRef.componentInstance.getResult().subscribe((result: boolean) => {
        if (result) {
          execute();
        }
      });
    }
  }

  startTokenExpirationCheck(): void {
    this.tokenExpirationSubscription = this.validateToken.getTokenExpirationStatus().subscribe((isExpired: boolean) => {
      if (isExpired) {
        if (this.cookies.get('id_token_user')) {
          this.signOut.SignOut('');
          this.stopTokenExpirationCheck();
          this.closeModal._CloseModal('btn-close-modal-loading');
          this.router.navigate(['/login']);
        }
      }
    });
  }

  stopTokenExpirationCheck(): void {
    if (this.tokenExpirationSubscription) {
      this.tokenExpirationSubscription.unsubscribe();
    }
  }

  /**
   * Registra la carga del script de HubSpot para la primera interacción del usuario.
   */
  private scheduleHubspotLoadOnInteraction() {
    // Si ya están registrados o el script ya se cargó (p.ej. por scroll), no hacer nada
    if (this.hubspotListenersAdded || this.chatLoadedByScroll) return;

    this.hubspotListenersAdded = true;

    // Lista de eventos de interacción
    const events: string[] = ['scroll', 'mousemove', 'touchstart'];

    // Llama a 'loadHubspotScriptNow' en el primer evento y se auto-elimina
    events.forEach((event) => {
      document.addEventListener(event, this.loadHubspotScriptNow, { once: true, passive: true });
    });

    // Fallback: si el usuario no interactúa, cárgalo después de 4 segundos
    setTimeout(this.loadHubspotScriptNow, 4000);
  }

  /**
   * La función que finalmente carga el script de HubSpot.
   * Se usa 'bind(this)' o una arrow function para mantener el contexto.
   */
  private loadHubspotScriptNow = () => {
    // Asegurarse de que no se cargue múltiples veces
    if (!document.querySelector('script[src="//js.hs-scripts.com/23231946.js"]')) {
      this.addScriptToHead('//js.hs-scripts.com/23231946.js');
    }

    // Limpiar otros listeners por si acaso
    const events: string[] = ['scroll', 'mousemove', 'touchstart'];
    events.forEach((event) => {
      document.removeEventListener(event, this.loadHubspotScriptNow);
    });
  };

  /**
   * Orquesta la lógica para cargar el chat de HubSpot y actualizar favicons según la ruta, campaña y condiciones de la página.
   * Separa la lógica en métodos auxiliares para mejorar la legibilidad y el mantenimiento.
   */
  LoadChatFaviconBrand() {
    if (!isPlatformBrowser(this.platformId)) return;

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const campaignParam = params.get('campaign');
    const locationPath = window.location.pathname;
    const is_active_campaign_month = this.utils.isCampaignMonthReturnBool();
    const detect_screen_mode = !!this.utils.detectScreenMode();

    const views_no_loads_chaths_is_active_campaign_month = new Set(['/', '/cdt-cupido', '/dias-azules']);
    const no_load_chaths_onpage = new Set([
      '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
      '/v2/preguntas-ban100',
      '/v2/preguntas-bancamia',
      '/v2/preguntas-bancow',
      '/v2/preguntas-bancomundomujer',
      '/v2/preguntas-mibanco',
      '/v2/preguntas-credifamilia',
      '/v2/preguntas-coltefinanciera',
      '/v2/preguntas-iris',
      '/v2/preguntas-cdturbo',
      '/v2/preguntas-koa',
      '/v2/datos-personales',
      '/v2/datos-financieros',
      '/confirma-tus-datos',
      '/cdt-simulador',
      '/cdt-turbo',
      '/bienvenida-usuario-retorno',
      '/widget-simulador',
      '/pauta/remarketing/hoy-los-bancos-ofrecen',
      '/pauta/llamada/hoy-los-bancos-ofrecen',
      '/pauta/control/hoy-los-bancos-ofrecen',
      '/hoy-los-bancos-ofrecen',
      '/portal/dashboard',
      '/moneymonastery-2025',
    ]);
    const load_chats_with_scroll = ['/ab-testing/hoy-los-bancos-ofrecen'];
    const no_load_chat_param_viewapp = new Set([
      '/retirar-cdt-antes-de-tiempo-es-posible-con-mejorcdt',
      '/portal/dashboard',
    ]);
    const no_load_chats_in_mobile = new Set([
      '/transfiere-el-dinero',
      '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
      '/v2/preguntas-ban100',
      '/v2/preguntas-bancamia',
      '/v2/preguntas-bancow',
      '/v2/preguntas-bancomundomujer',
      '/v2/preguntas-mibanco',
      '/v2/preguntas-credifamilia',
      '/v2/preguntas-coltefinanciera',
      '/v2/preguntas-iris',
      '/v2/preguntas-cdturbo',
      '/v2/preguntas-koa',
      '/v2/datos-personales',
      '/v2/datos-financieros',
    ]);
    const is_viewapp_includes_route = no_load_chat_param_viewapp.has(locationPath) && !!params.get('view');

    // Carga el chat en un scroll específico.
    if (this.shouldLoadChatOnScroll(locationPath, load_chats_with_scroll)) {
      return this.handleChatLoadOnScroll();
    } else {
      this.resetChatScrollState();
    }

    if (
      this.shouldNotLoadChat(
        locationPath,
        no_load_chaths_onpage,
        is_viewapp_includes_route,
        detect_screen_mode,
        views_no_loads_chaths_is_active_campaign_month,
        is_active_campaign_month,
        no_load_chats_in_mobile,
      )
    ) {
      return this.handleNoChatLoad();
    }

    if (campaignParam) {
      if (this.handleCampaignChatLoad(campaignParam, true)) return;
    }

    // Si ninguna de las condiciones anteriores (scroll, no-load, campaña)
    // se cumplió, ejecutamos el caso default (mejorcdt).

    this.updateFaviconsAndScript(
      `${this.env?.S3_STATIC_FILES}/images/web/favicons/new`,
      this.globals_var.CAMPAIGN_MEJORCDT,
    );
    this.scheduleHubspotLoadOnInteraction();
  }

  /**
   * Determina si la ruta actual requiere cargar el chat por scroll.
   * @param locationPath Ruta actual
   * @param scrollPaths Array de rutas que requieren scroll
   * @returns boolean
   */
  private shouldLoadChatOnScroll(locationPath: string, scrollPaths: string[]): boolean {
    return scrollPaths.includes(locationPath);
  }

  /**
   * Maneja la lógica de carga del chat cuando se hace scroll en la página.
   * Carga el chat si no ha sido cargado por scroll previamente.
   */
  private handleChatLoadOnScroll(): void {
    if (!this.chatLoadedByScroll) {
      // Si el chat ya está cargado, lo removemos antes de continuar
      this.waitForHubSpotConversations().then(() => {
        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
          window.HubSpotConversations.widget.remove();
        }
      });
      const onScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        if (scrollPercent >= 10) {
          this.updateFaviconsAndScript(
            `${this.env?.S3_STATIC_FILES}/images/web/favicons`,
            this.globals_var.CAMPAIGN_MEJORCDT,
          );
          this.addScriptToHead('//js.hs-scripts.com/23231946.js');
          this.chatLoadedByScroll = true;
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /**
   * Reinicia el estado de carga por scroll para permitir recarga si el usuario navega entre rutas.
   */
  private resetChatScrollState(): void {
    this.chatLoadedByScroll = false;
  }

  /**
   * Determina si no se debe cargar el chat en la ruta actual.
   * @returns boolean
   */
  private shouldNotLoadChat(
    locationPath: string,
    noLoadPaths: Set<string>,
    isViewApp: boolean,
    detectScreenMode: boolean,
    noLoadMonthPaths: Set<string>,
    isActiveMonth: boolean,
    no_load_chats_in_mobile: Set<string>,
  ): boolean {
    return (
      noLoadPaths.has(locationPath) ||
      isViewApp ||
      this.env.BRAND !== 'mcdt' ||
      (!detectScreenMode && noLoadMonthPaths.has(locationPath) && isActiveMonth) ||
      (!detectScreenMode && no_load_chats_in_mobile.has(locationPath))
    );
  }

  /**
   * Maneja la lógica de rutas donde no se debe cargar el chat.
   */
  private handleNoChatLoad(): void {
    this.updateFaviconsAndScript(
      `${this.env?.S3_STATIC_FILES}/images/web/favicons`,
      this.globals_var.CAMPAIGN_MEJORCDT,
    );
    if (window.HubSpotConversations?.widget) {
      window.HubSpotConversations.widget.remove();
    }
  }

  /**
   * Maneja la lógica de carga del chat por campaña.
   * @param campaignParam Valor del parámetro de campaña
   * @param delayScript Si es true, retrasa la carga del script hasta la interacción
   * @returns boolean Si se realizó una acción y se debe salir del método principal
   */
  private handleCampaignChatLoad(campaignParam: string, delayScript: boolean = false): boolean {
    const campaign = campaignParam.toLowerCase();

    if (campaign === this.globals_var.FLAMINGO.toLowerCase()) {
      this.updateFaviconsAndScript(
        'https://static.mejorcdt.com/assets/favicons/flamingo',
        this.globals_var.CAMPAIGN_FLAMINGO,
      );
      if (this.retryAttempts > 0) {
        this.retryAttempts = 0;

        if (delayScript) {
          this.scheduleHubspotLoadOnInteraction();
        } else {
          this.addScriptToHead('//js.hs-scripts.com/23231946.js'); // (Comportamiento antiguo)
        }
      }
      return true;
    }

    if (campaign === this.globals_var.CAMPAIGN_CLAUDIAURIBE.toLowerCase()) {
      this.updateFaviconsAndScript(
        'https://static.mejorcdt.com/assets/favicons/claudiauribe',
        this.globals_var.CAMPAIGN_CLAUDIAURIBE,
      );
      this.retryAttempts = 0;
      return true;
    }
    if (this.retryAttempts > 0) {
      this.retryAttempts--;
      setTimeout(() => this.LoadChatFaviconBrand(), 1000);
      return true;
    }
    return false;
  }

  updateFaviconsAndScript(faviconBaseUrl: string, brand: string) {
    const sizes = [16, 32, 48, 64, 128];
    sizes.forEach((size) => {
      if (this.env.BRAND != 'mcdt') {
        this.favicons[`ico${size}`].href = `${this.env.S3_STATIC_FILES}/brands/${this.env.BRAND}/img/icon${size}.png`;
      } else {
        if (brand === this.globals_var.CAMPAIGN_MEJORCDT) {
          this.favicons[`ico${size}`].href = `${faviconBaseUrl}/icon${size}.jpg`;
        } else {
          this.favicons[`ico${size}`].href = `${faviconBaseUrl}.png`;
        }
      }
    });
  }

  /* Si existe el paremetro tube, significa que el usuario accedio por el link y lo redireccionaremos al paso en que está  */
  backToStep() {
    const isIdProcess = !!this.utils.getQueryParam('process_id');
    const isIdTicket = !!this.utils.getQueryParam('ticket');
    const isPathHome = window.location.pathname === '/';
    const query_url = {
      process_id: this.utils.getQueryParam('process_id'),
      ticket: this.utils.getQueryParam('ticket'),
      campaign: this.utils.getQueryParam('campaign'),
    };
    if ((isIdProcess || isIdTicket) && isPathHome) {
      this.router.navigate(['/continuar-proceso'], { queryParams: query_url });
    }
  }

  /* Identificamos de que referido viene */
  RefInfluencer(query: any) {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var resp = urlParams.get(query);

    if (resp != null) {
      this.cookies.save('ref', resp, 1);
    }
  }

  private addScriptToHead(src: string): void {
    // Asegurar que el src use HTTPS para cumplir con CSP
    const secureSrc = src.startsWith('//') ? `https:${src}` : src;

    const script = document.createElement('script');
    script.src = secureSrc;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  // Función para esperar a que HubSpotConversations esté disponible
  waitForHubSpotConversations(): Promise<void> {
    return new Promise((resolve) => {
      const checkHubSpotConversations = () => {
        // Verificar si HubSpotConversations está disponible en la ventana global
        if (window.HubSpotConversations) {
          resolve(); // Resuelve la promesa cuando HubSpotConversations está disponible
        } else {
          setTimeout(checkHubSpotConversations, 100); // Revisar cada 100 ms hasta que esté disponible
        }
      };
      // Iniciar el proceso de espera
      checkHubSpotConversations();
    });
  }

  onWindowScroll() {
    if (!isPlatformBrowser(this.platformId)) return;

    const locationPath = window.location.pathname;
    const only_desktop_in_path = ['/portal/dashboard'];

    if (
      (this.globals_var.PATHS_SHOW_DOWNLOAD_APP_FULLSCREEN.includes(`${locationPath}`) ||
        locationPath.startsWith('/mejores-cdt-')) &&
      this.env.BRAND == 'mcdt'
    ) {
      const requiresDesktopOnly = only_desktop_in_path.includes(locationPath);
      if (requiresDesktopOnly && this.resolution !== 1) return;

      const threshold = 600;
      const position = window.innerHeight + window.scrollY;
      const height = document.body.offsetHeight;

      if (position >= height - threshold && !this.flagModalDownloadApp) {
        this.loadModalComponent();
        this.flagModalDownloadApp = true;
      }
    }
  }

  private async loadModalComponent() {
    const { ModalDownloadAppFullscreenComponent } =
      await import('./modals/modal-download-app-fullscreen/modal-download-app-fullscreen.component');

    this.ngZone.run(() => {
      this.container.createComponent(ModalDownloadAppFullscreenComponent);
    });
  }
}
